import React from "react";

import { ReactComponent as MapF0 } from "assets/images/map_f0.svg";
import { ReactComponent as MapF1 } from "assets/images/map_f1_2026_05.svg";
import { ReactComponent as MapF2 } from "assets/images/map_f2_2026_05.svg";
import { ReactComponent as MapF3 } from "assets/images/map_f3_2026_05.svg";
import { ReactComponent as MapF4 } from "assets/images/map_f4.svg";


import Logos from "components/Logos";
import { pinSize } from "config/sizes";
import styles from "./styles.module.css";
import ShopTags from "components/ShopTags";
import PathGuide from "components/PathGuide";
import Skeleton from "react-loading-skeleton";
import Facilities from "components/Facilities";
import iconPin from "assets/images/icon_pin.svg";
import DynamicIcon from "components/DynamicIcon";
import { setupAndSearch } from "utils/searchPath";
import { getCachedItem } from "utils/localStorage";
import startPin from "assets/images/icon_start.svg";
import verticesOnFloor from "config/verticesOnFloor";
import { arrayOf, number, shape, array, bool, func, object } from "prop-types";
import {
  deviceFloorLevel,
  deviceSvgId,
  mapRealLifeRatio,
} from "config/constants";
import StaticData from "components/StaticData";
import Title from "components/Title";
import Floor1TitleList from "components/Floor1TitleList";
import useSVGCoordinateTracker from "hooks/useSVGCoordinateTracker";

MapShape.propTypes = {
  notDestinationButElevator: bool,
  getTravelCost: func,
  connections: array,
  floorIndex: number,
  vertices: array,
  rotate: number,
  start: number,
  end: number,
  pinsList: arrayOf(
    shape({
      x: number,
      y: number,
    })
  ),
  className: object,
};

MapShape.defaultProps = {
  floorIndex: 0,
};

function MapShape(props) {
  const deviceFloorlvl = getCachedItem(deviceFloorLevel);
  const definedVertices = verticesOnFloor[deviceFloorlvl];
  const deviceLocation = definedVertices?.find(
    ({ id }) => id === getCachedItem(deviceSvgId)
  );

  const {
    start,
    end,
    rotate,
    vertices,
    floorIndex,
    connections,
    getTravelCost,
    notDestinationButElevator,
    layout,
    className,
  } = props;

  const modelSvg = React.useRef();
  const svgContainer = React.useRef();

  useSVGCoordinateTracker(svgContainer, true); // Thay đổi thành true để bật tracker cho mọi tầng
  const [loading, setLoading] = React.useState(false);
  const [viewBox, setViewBox] = React.useState({
    width: 0,
    widthHeightRatio: 0,
  });
  const [orientation, setOrientation] = React.useState(rotate || 0);
  const [svgContainerWidthHeight, setSvgContainerWidthHeight] =
    React.useState(null);
  const [path, setPath] = React.useState([]);

  const switchMapSvg = React.useMemo(() => {
    switch (floorIndex) {
      case 0:
        return <MapF0 ref={modelSvg} />
      case 1:
        return <MapF1 ref={modelSvg} />;
      case 2:
        return <MapF2 ref={modelSvg} />;
      case 3:
        return <MapF3 ref={modelSvg} />;
    }
  }, [floorIndex]);
  const svgViewBox = React.useRef("");
  const setupAndFindPath = React.useCallback(
    (connections, vertices, startSvgId, endSvgId) => {
      const result = setupAndSearch(
        connections,
        vertices,
        startSvgId,
        endSvgId
      );
      setPath(result);
    },
    ["didMount"]
  );

  const onSearch = (e) => {
    e.preventDefault();
    const startId = e.currentTarget[0].value;
    const endId = e.currentTarget[1].value;
    setupAndFindPath(connections, vertices, startId, endId);
  };

  React.useEffect(() => {
    if (floorIndex !== 4 && floorIndex !== 0) {
      const container = svgContainer.current;
      const offsetTopFigure = container.getClientRects().top;
    }
  }, [rotate]);

  React.useEffect(() => {
    setupAndFindPath(connections, vertices, start, end);
  }, [floorIndex, start, end]);

  React.useEffect(() => {
    if (path.length) {
      const gCost = path.reduce((acc, { g }) => acc + g, 0);
      getTravelCost(gCost / mapRealLifeRatio);
    }
  }, [path]);

  React.useEffect(() => {
    if (svgContainer.current) {
      const container = svgContainer.current;
      const targetSVG = container.querySelector("svg");
      svgViewBox.current = targetSVG.getAttribute("viewBox");
      const domEle = container.getClientRects()[0];
      if (domEle) {
        const { width, height } = domEle;
        setSvgContainerWidthHeight({ width, height });
      }
    }
  }, ["didMount"]);

  const PathToTenant = () =>
    React.useMemo(() => {
      if (path.length) {
        return (
          <PathGuide
            path={path}
            rotate={rotate}
            notDestinationButElevator={notDestinationButElevator}
          />
        );
      }
      return null;
    }, [path]);

  React.useEffect(() => {
    setOrientation(rotate);
  }, [svgContainerWidthHeight]);

  return (
    <>
      {loading ? (
        <div className="loading">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <Skeleton />
        </div>
      ) : floorIndex === 4 ? (
        <div
          className={`${styles.svg_container} ${styles[`rotate_${orientation}`]} ${layout ? styles[layout + "_ms"] : ""}`}
        >
          <MapF4 />
        </div>
      ) : floorIndex === 0 ? (
        <div
          className={`${styles.svg_container} ${styles[`rotate_${orientation}`]} ${layout ? styles[layout + "_ms"] : ""}`}
        >
          <MapF0 />
        </div>
      ) : (
        <>
          <div
            className={`${styles.svg_container} ${styles[`rotate_${orientation}`]} ${layout ? styles[layout + "_ms"] : ""}`}
            ref={svgContainer}
          >
            {switchMapSvg}
            <svg className={styles.svg_path} viewBox={svgViewBox.current || undefined}>
              <StaticData floorLevel={floorIndex} rotate={rotate} />
              <ShopTags floorLevel={floorIndex} rotate={rotate} />
              <Facilities rotate={rotate} floorIndex={floorIndex} />
              <Logos rotate={rotate} floorLevel={floorIndex} />
              <Title rotate={rotate} floorLevel={floorIndex} />
              <PathToTenant />
              {props.pinsList?.map((item, index) => (
                <DynamicIcon
                  logoRectSize={pinSize}
                  key={item.id !== undefined ? item.id : index}
                  id={item.id}
                  floorLevel={floorIndex}
                  rotate={rotate}
                  href={iconPin}
                  x={item?.x}
                  y={item?.y}
                  animation={true}
                />
              ))}
              {floorIndex === deviceFloorlvl && (
                <DynamicIcon
                  key="pin_start"
                  logoRectSize={50}
                  rotate={rotate}
                  x={deviceLocation?.cx}
                  y={deviceLocation?.cy}
                  href={startPin}
                />
              )}
            </svg>
          </div>
          {/* FOR TEST ONLY */}
          <form
            onSubmit={onSearch}
            className="form-group mx-sm-3 mb-2 display_none"
          >
            <input
              type="input"
              name="start-id"
              placeholder="start ID"
              defaultValue="0"
              className="col-md-3 form-control"
            />
            <input
              type="input"
              name="end-id"
              placeholder="end ID"
              defaultValue="52"
              className="col-md-3 form-control"
            />
            <br />
            <button type="submit" className="btn btn-primary">
              Test Search
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => setPath([])}
            >
              Clear Path
            </button>
          </form>
          {/* \\ FOR TEST ONLY */}
        </>
      )}
    </>
  );
}

export default MapShape;
